import Cookies from 'js-cookie';
import { ApplicationInfo } from '@/const/application';
import { ApplicationUrlMap, fleAppEnv } from '@/const/serviceEnv';

// 校验token是否是当前应用的token
export const checkTokenByPlatform = () => {
  const token = Cookies.get('token');
  if (token) {
    const tokenParts = token.split('-');
    const tokenSystemId = tokenParts[tokenParts.length - 1];
    if (tokenSystemId !== ApplicationInfo.systemId) {
      // Cookies.remove('token');
      const loginUrl = `${ApplicationUrlMap['88buys']?.[fleAppEnv]}/login`;
      window.location.replace(loginUrl);
    } else {
      Cookies.set('systemId', tokenSystemId);
    }
  }
};